import { Log, Level, Logger } from 'ng2-logger';
import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import Moment from 'moment';
import * as Actions from '../constants/informationNote';
import { ISetAddInformationNote, ISetDeleteInformationNote, IInformationNoteData } from '../../models/action/informationNote';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';

const _logger = Log.create('InformationNote Reducer');

const setInformationNoteData = (newState: any, informationNotePageActionPayload: any  ) => {
    const informationNotePageAction = informationNotePageActionPayload?.InformationNoteData ? informationNotePageActionPayload.InformationNoteData[0] : null;
        newState.InformationNoteData = {
            activityId: informationNotePageAction ? informationNotePageAction.activityId : '',
            abbreviation: informationNotePageAction ? informationNotePageAction.abbreviation : '',
            name: informationNotePageAction ? informationNotePageAction.name : '',
            allowDownload: informationNotePageAction ? informationNotePageAction.allowDownload : false,
            description: informationNotePageAction ? informationNotePageAction.description : '',
            isCommon: informationNotePageAction?.isCommon ? 1 : 0,
            dateCriteria: informationNotePageAction ? informationNotePageAction.dateCriteria : 0,
            datePrerequisiteActivityHours: informationNotePageAction?.datePrerequisiteActivityHours ?? '',
            datePrerequisiteActivityId: informationNotePageAction?.datePrerequisiteActivityId ? [informationNotePageAction?.datePrerequisiteActivityId] : '',
            prerequisiteActivityId: informationNotePageAction?.prerequisiteActivityId ?? '',
            completionType: informationNotePageAction?.completionType ?? 1,
            alwaysOnTop: informationNotePageAction?.alwaysOnTop,
            dateRange: '',
            fileInputKey: '',
            photoUploadKey: '',
            activityConditionalBeginDate: informationNotePageAction?.beginDate,
            activityConditionalEndDate: informationNotePageAction?.endDate,
            termWeekIds: informationNotePageAction?.termWeekIds,
            selectedActivityOwnersTagIds: informationNotePageAction?.selectedActivityOwnersTagIds,
            selectedActivityUnitsTagIds: informationNotePageAction?.selectedActivityUnitsTagIds,
            selectedClass: informationNotePageAction?.selectedClass,
            allUnits: informationNotePageAction?.allUnits,
            courseId: informationNotePageAction?.courseId,
            file: informationNotePageAction?.file && informationNotePageAction?.file.length > 0 ? informationNotePageAction?.file : null,
            deletedFilesId: [],
            cardImgName: informationNotePageAction?.cardImgName,
            informationNoteActivityType : informationNotePageAction?.informationNoteActivityType ?? ActivityTypeEnums.InformationNote
        };
}

const informationNoteReducer = (state = GlobalState().informationNote, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {};
    if (action.type === Actions.actions.SET_INFORMATION_NOTE_DATA_DEFAULT) {
        newState.InformationNoteData = {
            isUpdate: false,
            isCommon: 0,
            name: '',
            description: '',
            filterActivityView: 'criterionDate',
            dateRange: '',
            selectActivity: [],
            note: 0,
            allUnits: false,
            selectUnits: [],
            selectCondition: [],
            selectOwner: [],
            completionType: 1,
            alwaysOnTop: true,
            dateCriteria: 0,
            fileInputKey: '',
            selectedClass: [],
            allowDownload: false,
            activitytype: '21',
            selectWeek: [],
            termWeekIds: [],
            activityTime: 0,
            selectedActivityUnitsTagIds: [],
            selectedActivityOwnersTagIds: [],
            prerequisiteActivityId: '',
            datePrerequisiteActivityId: '',
            cardImgName: '',
            informationNoteActivityType: ActivityTypeEnums.InformationNote
        };
    }
    if (action.type === Actions.actions.ADD_INFORMATION_NOTE_SET_ACTIVITY) {
        const informationNotePageActionPayload = (action as unknown) as ISetAddInformationNote;
        setInformationNoteData(newState, informationNotePageActionPayload);
    }
    if (action.type === Actions.actions.DELETE_INFORMATION_NOTE_SET_ACTIVITY) {
        const informationNotePageAction = action as ISetDeleteInformationNote;
        newState.informationNote.deleteInformationNoteStatus = informationNotePageAction.deleteInformationNoteStatus;
    }
    return Object.assign({}, state, newState);
};

export default informationNoteReducer;
